import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';
import React from 'react';

const styles = require('./Hint.module.scss');

export type HintVariant = 'neutral' | 'error';

export interface HintProps {
  message: React.ReactNode;
  variant?: HintVariant;
  id?: string;
  className?: string;
}

const Hint: React.FC<HintProps> = ({ message, variant = 'neutral', id, className }) => {
  const isError = variant === 'error';

  const wrapperClass = classNames(
    styles['ui-hint'],
    { [styles['ui-hint--error']]: isError },
    className,
  );

  return (
    <div className={wrapperClass} id={id} role={isError ? 'alert' : undefined}>
      <Icon
        name={isError ? 'triangleAlert' : 'info'}
        color={`${variant}-border-base`}
        size="sm"
        aria-hidden="true"
      />
      <p className={styles['ui-hint__text']}>{message}</p>
    </div>
  );
};

export default Hint;
